import Header from "../../components/Header";
import LinksContainer from "../../components/LinksContainer";
import WaveFooter from "../../components/WaveFooter";

export default function Links() {
    return (
      <>
      <Header />
      <LinksContainer />
      <WaveFooter />
      </>
    );
  }